// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"ModalButton_modalButton__2DhV6","fullWidth":"ModalButton_fullWidth__36ErM","modalItem":"ModalButton_modalItem__Lk067"};